// extracted by mini-css-extract-plugin
module.exports =  {"perks":"AboutSectionPerks-module_perks_c2b41","perksButton":"AboutSectionPerks-module_perksButton_b2693"};